module.exports = __webpack_public_path__ + "static/count_strahd_von_zarovich-9c44ebd11455b9a640e29205c2a66347.jpg";